const hasHexBuiltin =
  // @ts-ignore
  typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function'

const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 } as const
const asciiToBase16 = (ch: number): number | undefined => {
  if (ch >= asciis._0 && ch <= asciis._9) return ch - asciis._0 // '2' => 50-48
  if (ch >= asciis.A && ch <= asciis.F) return ch - (asciis.A - 10) // 'B' => 66-(65-10)
  if (ch >= asciis.a && ch <= asciis.f) return ch - (asciis.a - 10) // 'b' => 98-(97-10)
  return
}

export const fromHex = (hex: string): Uint8Array => {
  if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex)
  // @ts-ignore
  if (hasHexBuiltin) return Uint8Array.fromHex(hex)
  const hl = hex.length
  const al = hl / 2
  if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl)
  const array = new Uint8Array(al)
  for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
    const n1 = asciiToBase16(hex.charCodeAt(hi))
    const n2 = asciiToBase16(hex.charCodeAt(hi + 1))
    if (n1 === undefined || n2 === undefined) {
      const char = hex[hi] + hex[hi + 1]
      throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi)
    }
    array[ai] = n1 * 16 + n2 // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
  }
  return array
}

const isBytes = (a: unknown): a is Uint8Array => {
  return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array')
}

const abytes = (value: Uint8Array, length?: number, title: string = ''): Uint8Array => {
  const bytes = isBytes(value)
  const len = value?.length
  const needsLen = length !== undefined
  if (!bytes || (needsLen && len !== length)) {
    const prefix = title && `"${title}" `
    const ofLen = needsLen ? ` of length ${length}` : ''
    const got = bytes ? `length=${len}` : `type=${typeof value}`
    throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got)
  }
  return value
}

const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'))

export const toHex = (bytes: Uint8Array): string => {
  abytes(bytes)
  // @ts-ignore
  if (hasHexBuiltin) return bytes.toHex()
  // pre-caching improves the speed 6x
  let hex = ''
  for (let i = 0; i < bytes.length; i++) {
    hex += hexes[bytes[i]]
  }
  return hex
}
